import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    maxWidth: 520
  },
  content: {
    padding: theme.spacing(4)
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  subtitle: {
    marginBottom: theme.spacing(4)
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  addressLine: {
    marginTop: theme.spacing(3)
  },
  notification: {
    marginTop: theme.spacing(3)
  },
  actions: {
    marginTop: theme.spacing(5),
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));

export default useStyles;
